const mobile = `@media (max-width: 375px)`;
const tablet = `@media (max-width: 744px)`;
const laptop = `@media (max-width: 1023px)`;
const desktop = `@media (max-width: 1399px)`;
const desktopBig = `@media (max-width: 1799px)`;

export {
  mobile,
  tablet,
  laptop,
  desktop,
  desktopBig
}